import createIcon from '../../createIcon';

/**
 * @component @name ShoppingBasket
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMjEgOS40OTAwMUwxMi44MyAyLjkzMDAxQzEyLjY0IDIuNjUwMDEgMTIuMzIgMi41MTAwMSAxMiAyLjUxMDAxQzExLjY4IDIuNTEwMDEgMTEuMzYgMi42NTAwMSAxMS4xNyAyLjk0MDAxTDYuNzkgOS40OTAwMUgyQzEuNDUgOS40OTAwMSAxIDkuOTQwMDEgMSAxMC40OUMxIDEwLjU4IDEuMDEgMTAuNjcgMS4wNCAxMC43NkwzLjU4IDIwLjAzQzMuODEgMjAuODcgNC41OCAyMS40OSA1LjUgMjEuNDlIMTguNUMxOS40MiAyMS40OSAyMC4xOSAyMC44NyAyMC40MyAyMC4wM0wyMi45NyAxMC43NkwyMyAxMC40OUMyMyA5Ljk0MDAxIDIyLjU1IDkuNDkwMDEgMjIgOS40OTAwMUgxNy4yMVpNOSA5LjQ5MDAxTDEyIDUuMDkwMDFMMTUgOS40OTAwMUg5Wk0xMiAxNy40OUMxMC45IDE3LjQ5IDEwIDE2LjU5IDEwIDE1LjQ5QzEwIDE0LjM5IDEwLjkgMTMuNDkgMTIgMTMuNDlDMTMuMSAxMy40OSAxNCAxNC4zOSAxNCAxNS40OUMxNCAxNi41OSAxMy4xIDE3LjQ5IDEyIDE3LjQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShoppingBasket = createIcon('ShoppingBasket', [
  [
    'path',
    {
      d: 'M17.21 9.49001L12.83 2.93001C12.64 2.65001 12.32 2.51001 12 2.51001C11.68 2.51001 11.36 2.65001 11.17 2.94001L6.79 9.49001H2C1.45 9.49001 1 9.94001 1 10.49C1 10.58 1.01 10.67 1.04 10.76L3.58 20.03C3.81 20.87 4.58 21.49 5.5 21.49H18.5C19.42 21.49 20.19 20.87 20.43 20.03L22.97 10.76L23 10.49C23 9.94001 22.55 9.49001 22 9.49001H17.21ZM9 9.49001L12 5.09001L15 9.49001H9ZM12 17.49C10.9 17.49 10 16.59 10 15.49C10 14.39 10.9 13.49 12 13.49C13.1 13.49 14 14.39 14 15.49C14 16.59 13.1 17.49 12 17.49Z',
      key: 'hv00sy',
    },
  ],
]);

export default ShoppingBasket;
